let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("arhgZ"), load("8BM7C")]).then(() => parcelRequire('aABDg'));